
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 8"}},[_c('path',{attrs:{"d":"M.5 8h1a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v7a.5.5 0 00.5.5zM4 .5v7a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5z"}})])
      }
    
      }
    